<template>
  <div class="taxa_box">
    <div class="left">
      <svg
        width="96"
        height="96"
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_5202_50015)">
          <path
            d="M4.26397 71.3699C3.13232 71.3699 2.04702 70.9203 1.24682 70.1201C0.446618 69.3199 -0.00292969 68.2346 -0.00292969 67.103V27.6341C-0.00292969 26.5024 0.446618 25.4171 1.24682 24.6169C2.04702 23.8167 3.13232 23.3672 4.26397 23.3672H91.7302C92.8618 23.3672 93.9471 23.8167 94.7473 24.6169C95.5475 25.4171 95.9971 26.5024 95.9971 27.6341V67.103C95.9971 68.2346 95.5475 69.3199 94.7473 70.1201C93.9471 70.9203 92.8618 71.3699 91.7302 71.3699H4.26397ZM63.9953 30.8343V63.9028C63.9953 64.4686 64.2201 65.0113 64.6202 65.4114C65.0203 65.8115 65.5629 66.0362 66.1287 66.0362H88.53C89.0958 66.0362 89.6385 65.8115 90.0386 65.4114C90.4387 65.0113 90.6634 64.4686 90.6634 63.9028V30.8343C90.6634 30.2684 90.4387 29.7258 90.0386 29.3257C89.6385 28.9256 89.0958 28.7008 88.53 28.7008H66.1287C65.5629 28.7008 65.0203 28.9256 64.6202 29.3257C64.2201 29.7258 63.9953 30.2684 63.9953 30.8343ZM34.6603 30.8343V63.9028C34.6603 64.4686 34.8851 65.0113 35.2852 65.4114C35.6853 65.8115 36.228 66.0362 36.7938 66.0362H59.195C59.7608 66.0362 60.3035 65.8115 60.7036 65.4114C61.1037 65.0113 61.3285 64.4686 61.3285 63.9028V30.8343C61.3285 30.2684 61.1037 29.7258 60.7036 29.3257C60.3035 28.9256 59.7608 28.7008 59.195 28.7008H36.7938C36.2289 28.7022 35.6876 28.9276 35.2886 29.3276C34.8897 29.7275 34.6657 30.2694 34.6657 30.8343H34.6603ZM5.32537 30.8343V63.9028C5.32537 64.4686 5.55014 65.0113 5.95024 65.4114C6.35034 65.8115 6.89299 66.0362 7.45882 66.0362H29.8601C30.4259 66.0362 30.9685 65.8115 31.3686 65.4114C31.7687 65.0113 31.9935 64.4686 31.9935 63.9028V30.8343C31.9935 30.2684 31.7687 29.7258 31.3686 29.3257C30.9685 28.9256 30.4259 28.7008 29.8601 28.7008H7.45882C6.89299 28.7008 6.35034 28.9256 5.95024 29.3257C5.55014 29.7258 5.32537 30.2684 5.32537 30.8343ZM70.0479 59.2369C68.9673 53.6494 72.0427 50.0087 80.1498 43.827C78.9813 43.8989 77.8123 43.6962 76.7363 43.235C75.6807 42.7653 74.522 42.5758 73.3718 42.6845C72.7372 42.8462 72.1443 43.1413 71.6328 43.5502C71.1212 43.9591 70.7027 44.4724 70.4053 45.0559H66.6674V36.7013H70.6293C70.5738 37.6613 71.2949 37.5194 71.7941 37.2346C72.6341 36.8189 73.5785 36.6615 74.5079 36.7823C75.9622 37.0689 77.3972 37.4458 78.8046 37.9109C80.4176 38.4127 82.107 38.6233 83.7937 38.5328C85.0625 38.4996 86.2712 37.9847 87.1742 37.0928L89.3364 39.591C79.609 49.4124 81.976 55.5098 83.0609 59.2337L70.0479 59.2369ZM40.7129 59.2369C39.6313 53.6494 42.7077 50.0087 50.8138 43.827C49.6453 43.8991 48.4762 43.6963 47.4002 43.235C46.3444 42.7652 45.1852 42.5756 44.0347 42.6845C43.4002 42.8461 42.8074 43.1411 42.296 43.5501C41.7846 43.959 41.3664 44.4724 41.0692 45.0559H37.3271V36.7013H41.2879C41.2335 37.6613 41.9535 37.5194 42.4528 37.2346C43.2931 36.8188 44.2378 36.6614 45.1676 36.7823C46.6215 37.069 48.0562 37.446 49.4633 37.9109C51.0762 38.4127 52.7656 38.6233 54.4524 38.5328C55.7212 38.4996 56.9298 37.9847 57.8328 37.0928L59.9951 39.591C50.2676 49.4124 52.6347 55.5098 53.7195 59.2337L40.7129 59.2369ZM11.378 59.2369C10.2963 53.6494 13.3727 50.0087 21.4799 43.827C20.3114 43.8989 19.1423 43.6962 18.0663 43.235C17.0105 42.7652 15.8513 42.5756 14.7008 42.6845C14.0664 42.8463 13.4737 43.1415 12.9624 43.5504C12.451 43.9593 12.0327 44.4725 11.7353 45.0559H7.99218V36.7013H11.954C11.8985 37.6613 12.6196 37.5194 13.1189 37.2346C13.9588 36.8189 14.9032 36.6615 15.8326 36.7823C17.2865 37.0691 18.7212 37.446 20.1283 37.9109C21.7412 38.4128 23.4306 38.6234 25.1174 38.5328C26.3862 38.4996 27.5948 37.9847 28.4979 37.0928L30.659 39.591C20.9316 49.4124 23.2986 55.5098 24.3835 59.2337L11.378 59.2369Z"
            fill="#A5A7B2"
          />
        </g>
        <defs>
          <clipPath id="clip0_5202_50015">
            <rect
              width="96"
              height="96"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
      <span>Slots</span>
    </div>
    <div class="right">
      <div class="right_top flex-row">
        <div class="flex-row popBox">
          Jogador válido 
          <van-popover
            v-model="showPopover"
            trigger="click"
            theme="dark"
            :get-container="getContainer"
          >
            <div class="popContent">
              Condições válidas: O valor da recarga do nível inferior é ≥ 0 e a aposta é válida ≥ 0
            </div>
            <template #reference>
              <span class="ques">?</span>
            </template>
          </van-popover>
        </div>
        <div>
          <p>Desempenho</p>
          <p class="grey">
            (Unid: 10,000)
          </p>
        </div>
        <div>Valor do desconto por 10.000</div>
      </div>
      <div class="right_bottom">
        <div
          v-for="item in list"
          :key="item.des"
          class="right_item flex-row"
        >
          <div>{{ item.jo }}</div>
          <div>{{ item.des }}</div>
          <div>{{ item.val }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Popover } from 'vant';
export default {
    components: {
        vanPopover: Popover
    },
    data() {
        return {
            showPopover: false,
            list: [
                {
                    jo: 0,
                    des: 0,
                    val: 15
                },
                {
                    jo: 0,
                    des: 30,
                    val: 20
                },
                {
                    jo: 0,
                    des: 50,
                    val: 30
                },
                {
                    jo: 0,
                    des: 100,
                    val: 40
                },
                {
                    jo: 0,
                    des: 300,
                    val: 50
                },
                {
                    jo: 0,
                    des: 500,
                    val: 60
                },
                {
                    jo: 0,
                    des: 800,
                    val: 70
                },
                {
                    jo: 0,
                    des: 1000,
                    val: 80
                },
                {
                    jo: 0,
                    des: 3000,
                    val: 100
                },
                {
                    jo: 0,
                    des: 5000,
                    val: 120
                },
                {
                    jo: 0,
                    des: 10000,
                    val: 150
                },
                {
                    jo: 0,
                    des: 30000,
                    val: 230
                },
            ]
        }
    },
    computed: {
        getContainer() {
            return document.querySelector('.popBox')
        }
    }
}
</script>
<style lang="less" scoped>
@import '../../../assets/css/variables.less';
.flex-row {
    display: flex;
    align-items: center;
    & > div {
        width: 33%;
    }
}
.popBox {
    position: relative;
    .popContent {
        width: 200px;
        padding: 4px 8px;
    }
}
.taxa_box {
    display: flex;
    padding: 10px;
    .left {
        width: 80px;
        height: 60px;
        background-color: @rechargeColor;
        box-sizing: border-box;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        svg {
            width: 30px;
            height: 25px;
            margin-bottom: 4px;
        }
        path {
            fill: @primary-color;
        }
        span {
            color: @primary-color;
            font-size: 13px;
        }
    }
    .right {
        flex: 1;
        .right_top {
            padding-left: 10px;
            text-align: center;
            border: 1px solid @bodercolor;
            background-color: @secondary-color;
            border-radius: 6px;
            color: @textcolorf;
            font-size: 13px;
            .ques {
                padding: 2px 4px;
                background-color: #9778ff;
                color: @primary-color;
                border-radius: 50%;
                font-size: 9px;
                line-height: 1;
            }
        }
        .right_bottom {
            .right_item {
                & > div {
                    width: 33%;
                    text-align: center;
                    height: 36px;
                    line-height: 36px;
                    color: @textcolorf;
                    &:last-child {
                        color: @rechargeColor;
                    }
                }
                &:nth-child(2n) {
                    background-color: @secondary-color;
                    border-radius: 8px;
                }
            }
        }
    }
}
.grey {
    color: @textcolor1;
}
</style>